export default __webpack_public_path__ + "static/media/Swarm_Code.224a4da4.txt";